import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { LoginServerService } from '../../features/authentication/services/login-server.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(LoginServerService); // Use inject to access the service
  if (authService.isAuthenticate()) {
    return true; // Allow access if authenticated
  } else {
    return false; // Block access if not authenticated
  }
};


